import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionWrapper, FadeIn } from './Shared';
export const FuncionaSection = () => {
  const tags = ['Rutinas diarias', 'Alimentación cotidiana', 'Trabajo y estrés', 'Problemas digestivos comunes', 'Hinchazón hormonal', 'Inflamación constante', 'Falta de energía', 'Sensación de pesadez diaria'];
  return <SectionWrapper className="bg-white" data-id="element-47">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-48">
        <FadeIn data-id="element-49">
          <h2 className="text-3xl md:text-4xl font-bold text-sage-900 mb-4" data-id="element-50">
            💖 Funciona en tu vida real
          </h2>
          <p className="text-lg text-slate-600" data-id="element-51">
            Diseñado para adaptarse a tu día a día, no al revés.
          </p>
        </FadeIn>
      </div>

      <div className="flex flex-wrap justify-center gap-3 md:gap-4 max-w-4xl mx-auto" data-id="element-52">
        {tags.map((tag, index) => <FadeIn key={index} delay={index * 0.05} data-id="element-53">
            <div className="flex items-center space-x-2 bg-sage-50 border border-sage-100 px-4 py-3 rounded-full shadow-sm hover:shadow-md transition-shadow" data-id="element-54">
              <div className="bg-sage-200 p-1 rounded-full" data-id="element-55">
                <CheckIcon className="w-4 h-4 text-sage-700" data-id="element-56" />
              </div>
              <span className="text-slate-700 font-medium text-sm md:text-base" data-id="element-57">
                {tag}
              </span>
            </div>
          </FadeIn>)}
      </div>
    </SectionWrapper>;
};